import { ControlValueAccessor } from "@angular/forms";

export class ValueAccessorBase<T> implements ControlValueAccessor {
  private innerValue: T | null;
  private changed = new Array<(value: T | null) => void>();
  private touched = new Array<() => void>();
  get value(): T | null {
    return this.innerValue;
  }
  set value(value: T | null) {
    if (this.innerValue !== value) {
      this.innerValue = value;
      this.changed.forEach((f) => f(value));
    }
  }
  touch() {
    this.touched.forEach((f) => f());
  }
  writeValue(value: T) {
    let previousValue = this.innerValue;
    this.innerValue = value;
    this.onValueWritten(previousValue, value);
  }
  protected onValueWritten(previousValue: T | null, newValue: T) {}
  registerOnChange(fn: (value: T | null) => void): void {
    this.changed.push(fn);
  }
  registerOnTouched(fn: () => void) {
    this.touched.push(fn);
  }
}
